module.exports = __webpack_public_path__ + "static/media/creative-tim-white-slim2.e5507a17.png";